import React from "react";

const LogoLaunchPad: React.FC = () => {
  return (
    <div className="bg-blue-700 font-semibold text-white rounded-md p-2 w-fit">
      LP
    </div>
  );
};

export default LogoLaunchPad;
